/**
 * @module components\ghModelView\propView\templates\check
 */
import Component from "vue-class-component";
import Base from "./../../base";
@Component
export default class Check extends Base {

  
}
